exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.blackscreen {\n  position: absolute;\n  background: rgba(0, 0, 0, 0.4);\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/cases/components/cases-modal-container/cases-modal-container.component.less
// module id = ../../../../../src/app/packages/menu-items/cases/components/cases-modal-container/cases-modal-container.component.less
// module chunks = main